<template>
    <div class="container-fluid" ref="start">
        <div class="row justify-content-center flex-nowrap">
            <div class="col-1">
            <div class="sticky-top" style="top: 50%" v-if="page != 1 && page != 0 && page <= landingPageId">
                <arrow direction="left" :route="getPrevPhaseRoute($route.params.routeName)" routeName="Zurück"> </arrow>
            </div>
            </div>
            <div class="col">
                <div class="container">
                    <!--<div class="row">
                        <horizontal-nav :phases="phases" :activPhase="phase.Name"></horizontal-nav>                        
                    </div>-->
                    <div class="d-flex justify-content-center" v-if="page <= lastPageId">
                        <div class="col text-center">
                            <h2 class="m-4" v-show="!isLoading">{{this.phase.Name}}</h2>
                            <h4 class="m-4" v-if="showHeader == true" v-show="!isLoading">
                                {{this.phase.Header}}
                            </h4>
                            <div v-show="isLoading">
                                <div class="spinner-border text-muted"></div>
                                <h4 class="m-4" >Fragen werden geladen...</h4>
                            </div>
                            <question-input class="text-left"
                                v-show="!isLoading"
                                :key="phaseQuestion.Sequence"
                                v-for="phaseQuestion in phaseQuestions"
                                v-bind:phaseQuestion="phaseQuestion"
                                @updatedAnswerHandler="handleUpdatedAnswer"
                                @loadedQuestionHandler="handleLoadedQuestion"
                                @submittedAnswerHandler="handleSubmittedAnswer"
                            >
                            </question-input>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center" v-else-if="page == landingPageId">
                        <div class="col text-center">
                            <h2 class="m-4">Die Dateneingabe wurde erfasst.</h2>
                            <h4 class="m-4">
                                Vielen Dank für die Teilnahme.
                            </h4>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center" v-else>
                        <div class="col text-center">
                            <h2 class="m-4">Fehler 404</h2>
                            <h4 class="m-4">Diese Seite wurde nicht gefunden.
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-1" v-show="allQuestionsAnswered">
                <div class="sticky-top" style="top: 50%" v-if="page < landingPageId">
                    <arrow direction="right" :route="getNextPhaseRoute($route.params.routeName)" routeName="Weiter"></arrow>
                </div>
                <div class="sticky-top" style="top: 50%" v-if="page == landingPageId">
                    <arrow direction="right" :route="getNextPhaseRoute($route.params.routeName)" routeName=" Zur Auswertung"></arrow>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Arrow from '../js/components/Arrow.vue';
import QuestionInput from '../js/components/QuestionInput.vue';

export default {
    name: "App",
    components: {
        Arrow,
        QuestionInput,
    },
    props: {
        phases: [],
        lastPageId: {} //get's dynamically passed and indicates for the arrow component, when to point to the result part
    },
    data: function() {
        return {
            phase: {},
            page: 0,
            showHeader: false,
            phaseQuestions: [],
            answers: [],
            landingPageId: {},
            countLoadedQuestionInputs: 0,
            isLoading: true,
            countAnsweredQuestionInputs: 0,
            allQuestionsAnswered: false,
        };
    },
    created() {
        console.log("Loading in created: "+ this.isLoading);
        this.countLoadedQuestionInputs = 0;
        this.landingPageId = this.lastPageId + 1;
        this.getPhase(this.$route.params.routeName);
        this.fetchPhaseQuestions();
    },    
    updated() {
        console.log("Entering Updated QuestionPhase");
        if(this.$route.params.routeName != this.page) {
            console.log("updated QuestionPhase.vue");
            this.countLoadedQuestionInputs = 0;
            this.countAnsweredQuestionInputs = 0;
            this.allQuestionsAnswered = false;
            //write given or changed answers to the database
            if (this.answers.length > 0) {
                console.log("answers:");
                console.log(this.answers);

                axios
                    .post("/api/upsertAnswers", {
                        Answers: this.answers
                    })
                    .catch(err => {
                        console.log("post of answers failed:");
                        console.log(err);
                    });
            }                        
            
            //reset answers array, since a new page is loaded
            this.answers = [];
            console.log("answers array reseted");

            this.getPhase(this.$route.params.routeName);
            this.fetchPhaseQuestions();
        }        
    },
    methods:
    {
        getPhase(routeName) {
            console.log("Get Phase entered");
            if (routeName < this.landingPageId) {
                this.phase = this.phases.find(phase => (phase.route == routeName)).phase;
            }
            this.page = routeName;
        },
        fetchPhaseQuestions() {
            if (this.page != this.landingPageId) {
                this.isLoading = true;
                console.log("Loading status: " + this.isLoading);
                axios
                    .get("/api/phaseQuestionsByPage/" + this.page)
                    .then(response => {
                        this.phaseQuestions = response.data;                    
                        console.log("fetched phaseQuestions:");
                        console.log(this.phaseQuestions);
                        if(this.phaseQuestions[0].ShowHeader == 1) {
                            this.showHeader = true;
                        }
                        else {
                            this.showHeader = false;
                        }
                    })
                    .catch(err => console.log(err))
            }
        },
        handleUpdatedAnswer(answer) {
            console.log("Event triggered.");
            console.log("emitted answer:");
            console.log(answer);

            this.answers[answer.QuestionId] = answer;
        },
        handleSubmittedAnswer(answer) {
            console.log("Event triggered.");
            console.log("submitted answer:");
            console.log(answer);
            this.countAnsweredQuestionInputs += 1;
            if(this.countAnsweredQuestionInputs == this.phaseQuestions.length) {
                this.allQuestionsAnswered = true;
            }
        },
        handleLoadedQuestion(loaded){
            console.log("Event triggered.");
            console.log("Emitted loaded status:");
            console.log(loaded);
            this.countLoadedQuestionInputs += 1;
            if(this.countLoadedQuestionInputs == this.phaseQuestions.length) {
                this.isLoading = false;
            }
        },
        //returns the route to the next phase
        //somehow the execution of this function, especially from the for-loop within it, is critically for rendering the content -> MM - 2022-07-19
        //the error with not being able to access the last page directly could be related with this error of not rendering content, when this function is not executed at a certain time. -> MM - 2022-07-19
        getNextPhaseRoute(curRoute) {
            console.log("function getNextPhaseRoute entered");
            console.log("curRoute:");
            console.log(curRoute);           
            if (curRoute == this.landingPageId) return "/result/overview"; //MM - 2022-07-19
            if (curRoute == this.lastPageId) return "/questions/page/" + (this.lastPageId + 1); //AM - 2022-10-08

            for (let i = 0; i < this.phases.length; i++) {
                if (
                    this.phases[i].route === curRoute &&
                    i + 1 <= this.phases.length
                ) {
                    if (this.phases[i + 1].route) {
                        return "/questions/page/" + this.phases[i + 1].route;
                    }
                }
            }
        },
        //returns the route to the previous phase
        getPrevPhaseRoute(curRoute) {
            console.log("function getPrevPhaseRoute entered");           
            if  (curRoute == this.landingPageId) return "/questions/page/" + this.lastPageId; //AM - 2022-10-08
            if  (curRoute == this.lastPageId) return "/questions/page/" + (this.lastPageId - 1); //AM - 2022-10-08

            for (let i = 0; i < this.phases.length; i++) {
                if (this.phases[i].route === curRoute && i - 1 >= 0) {
                    if (this.phases[i - 1].route) {
                        return "/questions/page/" + this.phases[i - 1].route;
                    }
                }
            }
        }
    }    
};
</script>